var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_9097)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7389 25.1126L39.4408 41.8505H34.6383L25.0893 28.1923V28.1914L23.6874 26.1865L12.5326 10.2305H17.3351L26.337 23.1076L27.7389 25.1126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3813 0H5.61871C2.51566 0 0 2.51566 0 5.61871V46.3813C0 49.4843 2.51566 52 5.61871 52H46.3813C49.4843 52 52 49.4843 52 46.3813V5.61871C52 2.51566 49.4843 0 46.3813 0ZM33.1673 44.097L23.5043 30.0337L11.4061 44.097H8.27932L22.1159 28.0139L8.27932 7.87628H18.8327L27.983 21.1933L39.4391 7.87628H42.5658L29.3717 23.2135H29.3709L43.7207 44.097H33.1673Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_9097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6529ef8fb0cfe09d1281c89fbca4e04a.svg";
export { ForwardRef as ReactComponent };